import { render, staticRenderFns } from "./AlertHistoryList.vue?vue&type=template&id=f21dcce0&scoped=true"
import script from "./AlertHistoryList.vue?vue&type=script&lang=js"
export * from "./AlertHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21dcce0",
  null
  
)

export default component.exports